<template>
  <div class="small">
    <pie-chart v-if="datacollection" :chart-data="datacollection"></pie-chart>
    <!-- <button @click="fillData()">Update</button> -->
  </div>
</template>

<script>
  import PieChart from './PieChart.js'

  export default {
    components: {
      PieChart
    },
    props: [
      'data'
    ],
    // name: 'randomlinechart',
    data () {
      return {
        datacollection: null
      }
    },
    mounted () {
      this.fillData()
      // console.log("=====> " + JSON.stringify(this.data))
    },
    methods: {
      fillData() {
        let tmpdatacollection = null
        if (this.data) {
          tmpdatacollection = {
            labels: Object.keys(this.data),
            datasets: [
              {
                label: 'Data One',
                // backgroundColor: '#f87979',
                backgroundColor: ['lightblue', '#424c53', '#ac7c42', 'silver', 'gold' ],
                data: Object.values(this.data)
              },
            ],
          }

        }
        // console.log(tmpdatacollection) 
        this.datacollection = tmpdatacollection
      }
      // fillData () {
      //   this.datacollection = {
      //     labels: ["A", "B", "C", "D"],
      //     datasets: [
      //       {
      //         label: 'Data One',
      //         // backgroundColor: '#f87979',
      //         // backgroundColor: ['gold', 'silver', '#ac7c42', '#424c53'],
      //         data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
      //       },
      //       // {
      //       //   label: 'Data Two',
      //       //   backgroundColor: '#083979',
      //       //   data: [this.getRandomInt(), this.getRandomInt()]
      //       // }
      //     ]
      //   }
      // },
      // getRandomInt () {
      //   return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      // }
    },
    watch: {
      data () {
        // console.log("watch PieChart => data changed")
        // console.log("=====> " + JSON.stringify(this.data))
        this.fillData()
      }
    } 
  }
</script>

<style>
  .small {
    max-width: 600px;
    margin:  30px auto;
  }
</style>